import React from 'react';
import { Route } from 'react-router-dom-v5-compat';

import PublicRoute from 'common/components/Auth/PublicRoute';
import RoutePath from '~types/RoutePath';

import Login from './Login';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import AcceptInvite from './AcceptInvite';
import ActivateAccount from './ActivateAccount';

const AuthRoutes = [
  <Route
    key={RoutePath.Login}
    path={RoutePath.Login}
    element={
      <PublicRoute>
        <Login />
      </PublicRoute>
    }
  />,
  <Route
    key={RoutePath.ForgotPassword}
    path={RoutePath.ForgotPassword}
    element={
      <PublicRoute>
        <ForgotPassword />
      </PublicRoute>
    }
  />,
  <Route
    key={RoutePath.ResetPassword}
    path={RoutePath.ResetPassword}
    element={
      <PublicRoute>
        <ResetPassword />
      </PublicRoute>
    }
  />,
  <Route key={RoutePath.AcceptInvite} path={RoutePath.AcceptInvite} element={<AcceptInvite />} />,
  <Route
    key={RoutePath.ActivateAccount}
    path={RoutePath.ActivateAccount}
    element={
      <PublicRoute>
        <ActivateAccount />
      </PublicRoute>
    }
  />,
];

export default AuthRoutes;
